import { render, staticRenderFns } from "./CtaPost.vue?vue&type=template&id=788279c2"
import script from "./CtaPost.vue?vue&type=script&lang=js"
export * from "./CtaPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports